export const USER_DETAILS_GET = 'USER_DETAILS_GET';
export const USER_SESSION_TYPE = 'USER_SESSION_TYPE';
export const PAYMENT_AMOUNT= 'PAYMENT_AMOUNT'
export const TAB_TYPE = 'TAB_TYPE'
export const FREE_SESSION = 'FREE_SESSION'

// export const USER_BOOKING_DETAILS_GET = 'USER_BOOKING_DETAILS_GET';
// export const USER_BOOKING_DETAILS_CLEAR = 'USER_BOOKING_DETAILS_CLEAR'